import React, { useState, useEffect } from "react";
import { Tab, Tabs, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import MainMenu from "../../components/MainMenu";
import Spinner from "../../components/Spiner";
import { requisitarAPI } from "../../components/AlertGeral";
import api from "../../services/api";
import { Creators as DiagnosticoActions } from "../../Store/Controls/diagnosticos";
import FormDiagnostico from "./diagnostico";
import FormEvolucao from "./evolucao";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import ModalDeImpressao from "../../components/ModalDeImpressao";

const CadastroDiagnostico = ({ history, match }) => {
  const [editForm, setEditForm] = useState(false);
  const [diagnostico, setDiagnostico] = useState({
    id_pessoa: "",
    queixa_principal: "",
    evolucoes: [],
    diagnosticoEVA: [],
  });
  const [captionForm, setCaptionForm] = useState("Cadastro de Diagnósticos");
  const [loading, setLoading] = useState(true);
  const [showTabEvolucao, setShowTabEvolucao] = useState(false);
  const [keyTab, setKeyTab] = useState("geral");

  const diagnosticos = useSelector((state) => state.diagnosticos);
  const dispatch = useDispatch();
  const [carregado, setCarregado] = useState(
    typeof match.params.id === "undefined"
  );

  // a listagem não traz as evoluções: busca o diagnóstico completo pelo id
  useEffect(() => {
    if (typeof match.params.id === "undefined") return;

    async function getDiagnostico() {
      const ret = await requisitarAPI(
        () => api.get(`diagnosticos/detalhe/${match.params.id}`),
        "Falha ao obter diagnóstico do servidor"
      );

      if (ret.erro || !ret.response.data) {
        history.push("/diagnosticos");
        return;
      }

      if (diagnosticos.some((item) => item.id == match.params.id)) {
        dispatch(
          DiagnosticoActions.editDiagnostico(
            ret.response.data.id,
            ret.response.data
          )
        );
      } else {
        dispatch(DiagnosticoActions.addDiagnostico(ret.response.data));
      }
      setCarregado(true);
    }

    getDiagnostico();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match.params.id]);

  useEffect(() => {
    if (!carregado) return;

    if (typeof match.params.id !== "undefined") {
      setCaptionForm("Edição de Diagnósticos");
      setEditForm(true);
      const diagnostico = diagnosticos.find(
        (item) => item.id == match.params.id
      );
      if (typeof diagnostico === "undefined") history.push("/diagnosticos");

      setDiagnostico(diagnostico);

      setShowTabEvolucao(true);

      if (history.location.pathname.toUpperCase().includes("CADASTRO"))
        setKeyTab("evolucao");
    } else if (typeof match.params.idCliente !== "undefined") {
      diagnostico.id_pessoa = parseInt(match.params.idCliente);
      setDiagnostico(diagnostico);
    }

    setLoading(false);
  }, [
    carregado,
    diagnostico,
    diagnosticos,
    match.params.idCliente,
    match.params.id,
    history,
  ]);

  const [toggleModal, setToggleModal] = useState({
    isOpen: false,
  });

  const handlePrint = async (values) => {
    setToggleModal({
      isOpen: true,
      values,
    });
  };

  return (
    <>
      <MainMenu navigation={history} />

      {/* Modal de Impressão */}
      <ModalDeImpressao
        toggleModal={toggleModal}
        setToggleModal={setToggleModal}
      />

      <div className="titulo-pagina">
        {" "}
        {captionForm}{" "}
        <Button
          variant="voltar"
          onClick={() => {
            history.push("/diagnosticos");
          }}
        >
          <FontAwesomeIcon icon={faChevronLeft} className="icone" /> Voltar para
          Diagnósticos
        </Button>
        <a
          href="/ajuda#diagnosticos"
          alt="Clique para acessar página de ajuda"
          style={{ float: "right" }}
          title="Clique para acessar página de ajuda"
        >
          <FontAwesomeIcon className="icone" icon={faQuestionCircle} />
        </a>
        <Spinner loading={loading} />
      </div>

      <div className="container-principal">
        <Tabs
          className="nav nav-pills flex-sm-row"
          style={{
            width: "100%",
            border: "0px",
            padding: "1rem",
            borderBottom: "0px",
            backgroundColor: "#f1f1f1",
          }}
          activeKey={keyTab}
          onSelect={(k) => setKeyTab(k)}
        >
          <Tab eventKey="geral" title="Geral">
            <FormDiagnostico
              handlePrint={handlePrint}
              match={match}
              history={history}
              diagnostico={diagnostico}
              setDiagnostico={setDiagnostico}
              editForm={editForm}
              setEditForm={setEditForm}
            />
          </Tab>

          <Tab
            disabled={!showTabEvolucao}
            eventKey="evolucao"
            title="Evolução"
            style={{ width: "100%" }}
          >
            <FormEvolucao
              history={history}
              diagnostico={diagnostico}
              setDiagnostico={setDiagnostico}
            />
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default CadastroDiagnostico;
